import React from 'react';
import PropTypes from 'prop-types';
import { Global } from '@emotion/core';
import AssistantWoff from "../../assets/fonts/Assistant/Assistant-VariableFont.woff";
import AssistantWoff2 from "../../assets/fonts/Assistant/Assistant-VariableFont.woff2";
import AssistantTtf from "../../assets/fonts/Assistant/Assistant-VariableFont.ttf";
import ArimoWoff from "../../assets/fonts/Arimo/Arimo-VariableFont.woff";
import ArimoWoff2 from "../../assets/fonts/Arimo/Arimo-VariableFont.woff2";
import ArimoTtf from "../../assets/fonts/Arimo/Arimo-VariableFont.ttf";

const GlobalStyles = ({ theme }) => (
  <Global
    styles={{
      'html, input, textarea, select, button': {
        fontFamily: theme.RTL
          ? '"Arimo", sans-serif'
          : '"Assistant", sans-serif',
      },
      '@font-face': [
        {
          fontFamily: 'Arimo',
          fontStyle: 'normal',
          fontWeight: '100 800',
          src: [
            'local("Arimo")',
            `url(${ArimoWoff2}) format("woff2")`,
            `url(${ArimoWoff}) format("woff")`,
            `url(${ArimoTtf}) format("truetype")`,
          ],
        },
        {
          fontFamily: 'Assistant',
          fontStyle: 'normal',
          fontWeight: '100 800',
          src: [
            'local("Assistant")',
            `url(${AssistantWoff2}) format("woff2")`,
            `url(${AssistantWoff}) format("woff")`,
            `url(${AssistantTtf}) format("truetype")`,
          ],
        },
      ],
    }}
  />
);

GlobalStyles.propTypes = {
  theme: PropTypes.object,
};

export default GlobalStyles;
